import _ from 'lodash'
import Decimal from 'decimal.js'

export function formatProfitRatio(value) {
  if (_.isNil(value)) {
    return '--%'
  }
  const percentage = formatProfitRatioValue(value)
  return `${percentage}%`
}

export function formatProfitRatioValue(value) {
  if (_.isNil(value)) {
    return null
  }
  return new Decimal(value).div(10000).toString()
}

export function integerOfProfitRatio(valueStr) {
  if (_.isNil(valueStr) || valueStr === '') {
    return null
  }
  return new Decimal(valueStr).mul(10000).toNumber()
}
